export enum DiseasesIds {
  LS = 'lynch-syndrome',
  FH = 'familial-hypercholesterolemia',
  HBOC = 'hereditary-breast-and-ovarian-cancer-syndrome',
}

export interface DiseaseCardProps {
  icon: any;
  isDataAvailable: boolean;
  resultsNumber: number;
  resultsPercentage: number;
  title: string;
  testId: DiseasesIds;
}
